import DtoReferencial from './DtoReferencial'

export default class DtoQuality extends DtoReferencial {
    constructor(obj) {
        super(obj)
    }
}
